import React from 'react';

import {Button, IconView, Image, View, XStack} from '@medad-sep/core';
import {useTranslation} from 'react-i18next';
import {ProfileMenu} from '@shared/components/AppTopBar/ProfileMenu';
import {useSectionSidebar} from '@shared/context/SectionSidebarContext';
import {useMedia} from 'tamagui';

export function AppTopBar(): JSX.Element {
  const {t} = useTranslation();
  const media = useMedia();
  const isMobile = !!(media?.xs || media?.sm);
  const {isOpen, toggle} = useSectionSidebar();

  return (
    <XStack
      paddingVertical="$1"
      paddingHorizontal="$3"
      backgroundColor="$background"
      justifyContent="space-between"
      alignItems="center"
      borderBottomColor="$border"
      overflow="scroll"
      borderBottomWidth="1px">
      <XStack alignItems="center" gap="$spacing-sm">
        {isMobile ? (
          <Button
            hierarchy="tertiary-gray"
            aria-label={t(isOpen ? 'action.close' : 'action.open')}
            prefix={<IconView icon={isOpen ? 'Cancel01Icon' : 'Menu01Icon'} size={20} />}
            onPress={toggle}
          />
        ) : null}
        <View width="$12">
          <Image objectFit="contain" source={{uri: '/logo.png', height: 40}} />
        </View>
      </XStack>
      <ProfileMenu />
    </XStack>
  );
}

AppTopBar.defaultProps = {
  menuItems: [],
};
